import StsLink from '../../../../models/sts-link.model';

import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import {
  animate,
  trigger,
  style,
  transition
} from '@angular/animations';
import { SafeHtml } from '@angular/platform-browser';

declare let ua_record_page_cancel: Function;

@Component({
  selector: 'app-sts-bs-dialog',
  templateUrl: './sts-bs-dialog.component.html',
  styleUrls: ['./sts-bs-dialog.component.scss'],
  animations: [ // animations will prevent dialog from closing on iOS devices
  ]
})
export class StsBsDialogComponent implements OnInit {
  @Input() closable = true;
  @Input() item: StsLink = null;
  @Input() visible: boolean;
  @Input() useIFrame = false;
  @Input() src: string;
  @Input() htmlContent: SafeHtml | null = null;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor() { }

  ngOnInit() { }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    if (typeof (ua_record_page_cancel) != "undefined")
      ua_record_page_cancel(this.item.href);
    
    const nodeList= document.querySelectorAll('a, input, button, router-outlet');
    nodeList.forEach(element => {
      element.removeAttribute('tabindex');
    });
  }
}
